import { useEffect } from 'react';
import { draggable } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';

interface Options {
  onDragStart?: () => void;
  onDrop?: () => void;
  disabled?: boolean;
}

export function useDraggableGroup(
  ref: React.RefObject<HTMLElement>,
  id: string,
  options: Options = {}
) {
  useEffect(() => {
    if (options.disabled || !ref.current) return;

    return draggable({
      element: ref.current,
      getInitialData: () => ({
        type: 'group',
        id,
      }),
      onDragStart: () => {
        options?.onDragStart?.();
      },
      onDrop: () => {
        options?.onDrop?.();
      },
    });
  }, [ref, id, options]);
}
